export default __webpack_public_path__ + "static/media/mars-solid.93c680bc.svg";